// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1794":"a0daf9c6","1819":"a0daf9c6","4015":"a0daf9c6","7351":"a0daf9c6","7723":"a0daf9c6"}[chunkId] + ".chunk.css";
};